// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.container {
  max-width: 100%;
  margin: 0;
  padding: 1rem;
}

.export-buttons-container {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
}

.export-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.2rem;
  background: #FF8C00;
  border: 1px solid #FF6B00;
  color: white;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.export-btn:hover {
  background: #FF6B00;
  border-color: #FF5500;
  transform: translateY(-1px);
}

.export-btn:active {
  transform: translateY(0);
}

.filters {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-group label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.filter-group input,
.filter-group select {
  padding: 0.6rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: border-color 0.2s;
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: #FF8C00;
}

.searchable-select {
  position: relative;
}

.searchable-select__control {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.6rem;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: inherit;
  color: #333;
  cursor: pointer;
  transition: border-color 0.2s;
  text-align: left;
}

.searchable-select__control:hover {
  border-color: #bbb;
}

.searchable-select.is-open .searchable-select__control {
  border-color: #FF8C00;
}

.searchable-select__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
}

.searchable-select__value.is-empty {
  color: #777;
}

.searchable-select__actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.searchable-select__clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 0.95rem;
  line-height: 1;
  color: #777;
  background: #eee;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.searchable-select__clear:hover {
  background: #ef4444;
  color: white;
}

.searchable-select__caret {
  color: #777;
  font-size: 0.8rem;
  transition: transform 0.15s;
}

.searchable-select.is-open .searchable-select__caret {
  transform: rotate(180deg);
}

.searchable-select__checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-right: 0.5rem;
  font-size: 0.75rem;
  color: white;
  flex-shrink: 0;
}

.searchable-select__checkbox.is-checked {
  background: #FF8C00;
  border-color: #FF8C00;
}

.searchable-select.is-multiple .searchable-select__option {
  display: flex;
  align-items: center;
}

.searchable-select__option-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.searchable-select__menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  z-index: 50;
  overflow: hidden;
}

.searchable-select__search {
  width: 100%;
  padding: 0.55rem 0.7rem;
  border: none;
  border-bottom: 1px solid #eee;
  font-size: 0.9rem;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
}

.searchable-select__search:focus {
  border-bottom-color: #FF8C00;
}

.searchable-select__list {
  list-style: none;
  margin: 0;
  padding: 0.25rem 0;
  max-height: 240px;
  overflow-y: auto;
}

.searchable-select__option {
  padding: 0.5rem 0.7rem;
  font-size: 0.9rem;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.searchable-select__option.is-highlighted {
  background: #fff3e6;
}

.searchable-select__option.is-selected {
  color: #FF8C00;
  font-weight: 600;
}

.searchable-select__empty {
  padding: 0.6rem 0.7rem;
  font-size: 0.9rem;
  color: #999;
  text-align: center;
}

.alerts-section {
  margin-bottom: 2rem;
}

.alerts-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #333;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 600;
}

.alerts-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.alert {
  background: white;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  border-left: 4px solid;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  transition: all 0.2s ease;
}

.alert:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.alert-error {
  border-left-color: #dc2626;
  background: #fef2f2;
}

.alert-warning {
  border-left-color: #f59e0b;
  background: #fffbeb;
}

.alert-success {
  border-left-color: #059669;
  background: #f0fdf4;
}

.alert-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
}

.alert-error .alert-icon {
  color: #dc2626;
  background: #fee2e2;
}

.alert-warning .alert-icon {
  color: #f59e0b;
  background: #fef3c7;
}

.alert-success .alert-icon {
  color: #059669;
  background: #d1fae5;
}

.alert-content {
  flex: 1 1;
}

.alert-title {
  font-weight: 700;
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
  color: #111827;
  letter-spacing: -0.01em;
}

.alert-message {
  font-size: 0.875rem;
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
}

.alert-action {
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  background: white;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.alert-error .alert-action {
  color: #ef4444;
}

.alert-warning .alert-action {
  color: #f59e0b;
}

.alert-success .alert-action {
  color: #10b981;
}

.alert-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* Taxa de Resposta */
.response-rate-section {
  margin-bottom: 2rem;
}

.response-rate-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
  text-align: center;
}

.response-rate-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.response-rate-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.5rem;
}

.response-rate-title {
  font-size: 1.3rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.response-rate-value {
  font-size: 4rem;
  font-weight: 800;
  margin: 1rem 0;
  line-height: 1;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.response-rate-subtitle {
  font-size: 1rem;
  opacity: 0.95;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.response-rate-details {
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.response-rate-detail {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.response-rate-label {
  font-size: 0.9rem;
  opacity: 0.9;
  font-weight: 500;
}

.response-rate-number {
  font-size: 1.5rem;
  font-weight: 700;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.metric-card {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.metric-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.metric-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.metric-icon.nps {
  background: linear-gradient(135deg, #FF8C00 0%, #FF6B00 100%);
  color: white;
}

.metric-icon.csat {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.metric-icon.ces {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
}

.metric-title {
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-value-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.metric-value {
  font-size: 3rem;
  font-weight: 700;
  background: linear-gradient(135deg, #FF8C00 0%, #FF6B00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-goal-indicator {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.metric-goal {
  font-size: 0.85rem;
  color: #6b7280;
  font-weight: 600;
}

.performance-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.05);
}

.metric-card.csat .metric-value {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-card.ces .metric-value {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.metric-subtitle {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 1rem;
}

.metric-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.metric-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background: #f9fafb;
  border-radius: 6px;
}

.metric-detail-label {
  font-size: 0.85rem;
  color: #666;
}

.metric-detail-value {
  font-size: 0.95rem;
  font-weight: 700;
  color: #333;
}

.metric-detail-value.promoters {
  color: #10b981;
}

.metric-detail-value.detractors {
  color: #ef4444;
}

.metric-detail-value.passives {
  color: #f59e0b;
}

.metric-detail-value.satisfied {
  color: #10b981;
}

.metric-detail-value.low-effort {
  color: #10b981;
}

.metric-detail-value.percentage {
  color: #10b981;
}

.chart-section {
  margin-bottom: 2rem;
}

.chart-card {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.chart-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.chart-subtitle {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 1.5rem;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* ==========================================================================
   Pesquisa de Manutenção — bloco próprio da campanha importada
   ========================================================================== */

.mnt-section {
  background: white;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0e6da;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.mnt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #f2f2f2;
}

.mnt-heading {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.mnt-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #FF8C00, #ff6b00);
  color: white;
  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.28);
  flex-shrink: 0;
}

.mnt-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #222;
  margin: 0;
  line-height: 1.2;
}

.mnt-export {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 1rem;
  border: 1px solid #ffdfc0;
  border-radius: 8px;
  background: #fff7ee;
  color: #b45a00;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
}

.mnt-export:hover:not(:disabled) {
  background: linear-gradient(135deg, #FF8C00, #ff6b00);
  border-color: transparent;
  color: white;
  box-shadow: 0 3px 10px rgba(255, 140, 0, 0.25);
}

.mnt-export:disabled {
  opacity: 0.6;
  cursor: progress;
}

/* Abas de campanha */

.mnt-tabs {
  display: flex;
  gap: 0.4rem;
  margin-top: 1rem;
  overflow-x: auto;
  padding-bottom: 0.25rem;
  scrollbar-width: thin;
}

.mnt-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.9rem;
  border: 1px solid #eee;
  border-radius: 999px;
  background: #fafafa;
  color: #666;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  max-width: 360px;
  transition: all 0.2s;
}

/* Só o nome encolhe; o contador não pode ser espremido pelo texto longo */
.mnt-tab-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.mnt-tab:hover {
  border-color: #ffd9ae;
  color: #b45a00;
}

.mnt-tab.active {
  background: linear-gradient(135deg, #FF8C00, #ff6b00);
  border-color: transparent;
  color: white;
  box-shadow: 0 3px 10px rgba(255, 140, 0, 0.25);
}

.mnt-tab-count {
  flex-shrink: 0;
  padding: 0.05rem 0.45rem;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.06);
  font-size: 0.7rem;
  font-weight: 700;
}

.mnt-tab.active .mnt-tab-count {
  background: rgba(255, 255, 255, 0.25);
}

/* Feedbacks escritos */

.mnt-feedback {
  margin-top: 1rem;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 1.15rem;
  background: #fdfdfd;
}

/* Reaproveita .comments-list / .comment-card da seção de Comentários; aqui só
   ajustamos a altura, já que este bloco comporta uma lista mais longa. */
/* Altura de ~5 cards (136px cada + 16px de gap), com folga para o topo do 6º
   aparecer e sinalizar que a lista rola.
   Especificidade dupla de propósito: \`.comments-list\` é declarada depois neste
   arquivo e, com peso igual, venceria por ordem mantendo os 600px dela. */
.comments-list.mnt-feedback-list {
  max-height: 780px;
}

/* Badge de nota no formato dos badges de NPS/CSAT/CES, colorido pela faixa.
   \`color\` vem depois das regras \`.tone-*\` genéricas, que pintariam o texto com
   a mesma cor do fundo. */
.comment-score.tone-good { background: #d1fae5; color: #047857; }
.comment-score.tone-warn { background: #fef3c7; color: #b45309; }
.comment-score.tone-bad { background: #fee2e2; color: #b91c1c; }
.comment-score.tone-empty { background: #f3f4f6; color: #6b7280; }

/* --- KPIs ---------------------------------------------------------------- */

.mnt-kpis {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 1.9fr;
  gap: 1rem;
  margin: 1.25rem 0;
}

.mnt-kpi {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  transition: border-color 0.2s, transform 0.2s;
}

.mnt-kpi:hover {
  border-color: #ffd9ae;
  transform: translateY(-2px);
}

.mnt-kpi-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.6rem;
}

.mnt-kpi-icon.send { background: #eef2ff; color: #4f46e5; }
.mnt-kpi-icon.answer { background: #ecfdf5; color: #059669; }
.mnt-kpi-icon.rate { background: #fff7ee; color: #ea7c00; }

.mnt-kpi-value {
  font-size: 1.85rem;
  font-weight: 800;
  color: #222;
  line-height: 1.1;
  letter-spacing: -0.5px;
}

.mnt-kpi-value.accent { color: #FF8C00; }

.mnt-kpi-label {
  font-size: 0.8rem;
  color: #777;
  margin-top: 0.2rem;
}

.mnt-kpi-hint {
  font-size: 0.72rem;
  color: #999;
  margin-top: 0.35rem;
}

.mnt-kpi-hint.warn { color: #c05600; font-weight: 600; }

/* --- Nota média + distribuição -------------------------------------------- */

.mnt-kpi.wide {
  background: linear-gradient(135deg, #fffaf4, #fff);
  border-color: #ffe6cc;
}

.mnt-score-area {
  display: flex;
  align-items: stretch;
  gap: 1.25rem;
}

.mnt-score-main {
  flex-shrink: 0;
  min-width: 130px;
}

.mnt-score-value {
  font-size: 2.6rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -1px;
}

.tone-good { color: #10b981; }
.tone-warn { color: #f59e0b; }
.tone-bad { color: #ef4444; }
.tone-empty { color: #bbb; }

/* Barra segmentada por faixa (promotores / neutros / detratores) */

.mnt-bands {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.85rem;
}

.mnt-band-bar {
  display: flex;
  height: 26px;
  border-radius: 8px;
  overflow: hidden;
  background: #f1f1f1;
}

.mnt-band {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.5s ease;
  min-width: 3px;
}

.mnt-band.tone-good { background: #10b981; }
.mnt-band.tone-warn { background: #f59e0b; }
.mnt-band.tone-bad { background: #ef4444; }

.mnt-band-value {
  font-size: 0.72rem;
  font-weight: 700;
  color: white;
  letter-spacing: 0.2px;
}

.mnt-band-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 1.1rem;
}

.mnt-band-item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.76rem;
  color: #666;
}

.mnt-band-item strong {
  color: #333;
  font-weight: 700;
}

.mnt-band-item em {
  font-style: normal;
  color: #aaa;
  font-size: 0.7rem;
}

.mnt-band-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mnt-band-dot.tone-good { background: #10b981; }
.mnt-band-dot.tone-warn { background: #f59e0b; }
.mnt-band-dot.tone-bad { background: #ef4444; }

/* --- Frames lado a lado --------------------------------------------------- */

.mnt-frames {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.mnt-frame {
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 1.15rem;
  background: #fdfdfd;
}

.mnt-frame-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #333;
}

.mnt-frame-subtitle {
  font-size: 0.78rem;
  color: #999;
  margin-bottom: 1.1rem;
}

.mnt-rows {
  display: flex;
  flex-direction: column;
  gap: 1.05rem;
}

.mnt-row-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.4rem;
}

.mnt-row-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #444;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mnt-row-score {
  font-size: 1.05rem;
  font-weight: 800;
  flex-shrink: 0;
}

.mnt-track {
  height: 8px;
  background: #f1f1f1;
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 3px;
}

.mnt-track.slim { height: 4px; }

.mnt-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.5s ease;
}

.mnt-fill.volume { background: linear-gradient(90deg, #FF8C00, #ffb057); }
.mnt-fill.rate { background: #10b981; }

.mnt-row-meta {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.72rem;
  color: #888;
  margin-top: 0.35rem;
  flex-wrap: wrap;
}

.mnt-row-rate {
  color: #059669;
  font-weight: 700;
}

.mnt-dot { color: #ddd; }

.mnt-empty {
  padding: 1.5rem 0;
  text-align: center;
  color: #aaa;
  font-size: 0.85rem;
}

@media (max-width: 1100px) {
  .mnt-kpis { grid-template-columns: repeat(2, 1fr); }
  .mnt-kpi.wide { grid-column: span 2; }
  .mnt-frames { grid-template-columns: 1fr; }
}

@media (max-width: 620px) {
  .mnt-kpis { grid-template-columns: 1fr; }
  .mnt-kpi.wide { grid-column: span 1; }
  .mnt-score-area { flex-direction: column; gap: 1rem; }
  .mnt-header { flex-direction: column; align-items: flex-start; }
}

.rankings-section {
  margin-bottom: 2rem;
}

.charts-grid-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
}

.comments-section {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.comments-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #333;
}

.comments-filter {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.9rem;
  cursor: pointer;
}

.comments-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 600px;
  overflow-y: auto;
}

.comment-card {
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: border-color 0.2s;
}

.comment-card:hover {
  border-color: #FF8C00;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.comment-info {
  flex: 1 1;
}

.comment-protocol {
  font-weight: 700;
  color: #FF8C00;
  font-size: 0.95rem;
}

.comment-protocol-link {
  font-weight: 700;
  color: #FF8C00;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.2s;
  display: inline-block;
}

.comment-protocol-link:hover {
  color: #FF6B00;
  text-decoration: underline;
  transform: translateX(2px);
}

/* Pesquisas importadas: identificador sem link para o CRM */
.comment-protocol-static:hover {
  color: #FF8C00;
  text-decoration: none;
  transform: none;
  cursor: default;
}

.comment-meta {
  font-size: 0.85rem;
  color: #666;
  margin-top: 0.25rem;
}

.comment-branch-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.1rem 0.6rem;
  background: #fff4e8;
  border: 1px solid #ffd9ae;
  border-radius: 999px;
  color: #c05600;
  font-weight: 600;
  font-size: 0.8rem;
  vertical-align: middle;
}

.comment-branch-badge svg {
  flex-shrink: 0;
}

.comment-scores {
  display: flex;
  gap: 0.5rem;
}

.comment-score {
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 700;
}

.comment-score.nps {
  background: #ede9fe;
  color: #7c3aed;
}

.comment-score.csat {
  background: #fce7f3;
  color: #ec4899;
}

.comment-score.ces {
  background: #dbeafe;
  color: #3b82f6;
}

.comment-text {
  font-size: 0.9rem;
  color: #333;
  line-height: 1.6;
  padding: 0.75rem;
  background: #f9fafb;
  border-radius: 6px;
  border-left: 3px solid #FF8C00;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 1.1rem;
  color: #666;
}

.error {
  background: #fef2f2;
  color: #ef4444;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #fee2e2;
  margin: 1rem 0;
}

@media (max-width: 768px) {
  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }

  .filters-grid {
    grid-template-columns: 1fr;
  }

  .comment-header {
    flex-direction: column;
    gap: 0.75rem;
  }

  .comment-scores {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;yEACyE;AACzE;;;0EAG0E;AAC1E;EACE,iBAAiB;AACnB;;AAEA;;0BAE0B;AAC1B,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;;AAEjE,8EAA8E;;AAE9E;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,wBAAwB,cAAc,EAAE;;AAExC;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB,cAAc,EAAE,gBAAgB,EAAE;;AAEvD,+EAA+E;;AAE/E;EACE,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA,aAAa,cAAc,EAAE;AAC7B,aAAa,cAAc,EAAE;AAC7B,YAAY,cAAc,EAAE;AAC5B,cAAc,WAAW,EAAE;;AAE3B,mEAAmE;;AAEnE;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C,yBAAyB,mBAAmB,EAAE;;AAE9C,+EAA+E;;AAE/E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB,WAAW,EAAE;;AAE/B;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,mBAAmB,oDAAoD,EAAE;AACzE,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW,WAAW,EAAE;;AAExB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY,qCAAqC,EAAE;EACnD,gBAAgB,mBAAmB,EAAE;EACrC,cAAc,0BAA0B,EAAE;AAC5C;;AAEA;EACE,YAAY,0BAA0B,EAAE;EACxC,gBAAgB,mBAAmB,EAAE;EACrC,kBAAkB,sBAAsB,EAAE,SAAS,EAAE;EACrD,cAAc,sBAAsB,EAAE,uBAAuB,EAAE;AACjE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".app {\n  min-height: 100vh;\n  background-color: #f5f7fa;\n}\n\n.container {\n  max-width: 100%;\n  margin: 0;\n  padding: 1rem;\n}\n\n.export-buttons-container {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.75rem;\n}\n\n.export-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.2rem;\n  background: #FF8C00;\n  border: 1px solid #FF6B00;\n  color: white;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.export-btn:hover {\n  background: #FF6B00;\n  border-color: #FF5500;\n  transform: translateY(-1px);\n}\n\n.export-btn:active {\n  transform: translateY(0);\n}\n\n.filters {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  margin-bottom: 2rem;\n}\n\n.filters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.filter-group label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.filter-group input,\n.filter-group select {\n  padding: 0.6rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  transition: border-color 0.2s;\n}\n\n.filter-group input:focus,\n.filter-group select:focus {\n  outline: none;\n  border-color: #FF8C00;\n}\n\n.searchable-select {\n  position: relative;\n}\n\n.searchable-select__control {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.6rem;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  color: #333;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  text-align: left;\n}\n\n.searchable-select__control:hover {\n  border-color: #bbb;\n}\n\n.searchable-select.is-open .searchable-select__control {\n  border-color: #FF8C00;\n}\n\n.searchable-select__value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.searchable-select__value.is-empty {\n  color: #777;\n}\n\n.searchable-select__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.searchable-select__clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  font-size: 0.95rem;\n  line-height: 1;\n  color: #777;\n  background: #eee;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.searchable-select__clear:hover {\n  background: #ef4444;\n  color: white;\n}\n\n.searchable-select__caret {\n  color: #777;\n  font-size: 0.8rem;\n  transition: transform 0.15s;\n}\n\n.searchable-select.is-open .searchable-select__caret {\n  transform: rotate(180deg);\n}\n\n.searchable-select__checkbox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  margin-right: 0.5rem;\n  font-size: 0.75rem;\n  color: white;\n  flex-shrink: 0;\n}\n\n.searchable-select__checkbox.is-checked {\n  background: #FF8C00;\n  border-color: #FF8C00;\n}\n\n.searchable-select.is-multiple .searchable-select__option {\n  display: flex;\n  align-items: center;\n}\n\n.searchable-select__option-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.searchable-select__menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n  z-index: 50;\n  overflow: hidden;\n}\n\n.searchable-select__search {\n  width: 100%;\n  padding: 0.55rem 0.7rem;\n  border: none;\n  border-bottom: 1px solid #eee;\n  font-size: 0.9rem;\n  font-family: inherit;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.searchable-select__search:focus {\n  border-bottom-color: #FF8C00;\n}\n\n.searchable-select__list {\n  list-style: none;\n  margin: 0;\n  padding: 0.25rem 0;\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.searchable-select__option {\n  padding: 0.5rem 0.7rem;\n  font-size: 0.9rem;\n  color: #333;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.searchable-select__option.is-highlighted {\n  background: #fff3e6;\n}\n\n.searchable-select__option.is-selected {\n  color: #FF8C00;\n  font-weight: 600;\n}\n\n.searchable-select__empty {\n  padding: 0.6rem 0.7rem;\n  font-size: 0.9rem;\n  color: #999;\n  text-align: center;\n}\n\n.alerts-section {\n  margin-bottom: 2rem;\n}\n\n.alerts-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.alerts-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.alert {\n  background: white;\n  padding: 1rem 1.25rem;\n  border-radius: 8px;\n  border-left: 4px solid;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  transition: all 0.2s ease;\n}\n\n.alert:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.alert-error {\n  border-left-color: #dc2626;\n  background: #fef2f2;\n}\n\n.alert-warning {\n  border-left-color: #f59e0b;\n  background: #fffbeb;\n}\n\n.alert-success {\n  border-left-color: #059669;\n  background: #f0fdf4;\n}\n\n.alert-icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.alert-error .alert-icon {\n  color: #dc2626;\n  background: #fee2e2;\n}\n\n.alert-warning .alert-icon {\n  color: #f59e0b;\n  background: #fef3c7;\n}\n\n.alert-success .alert-icon {\n  color: #059669;\n  background: #d1fae5;\n}\n\n.alert-content {\n  flex: 1;\n}\n\n.alert-title {\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n  font-size: 0.95rem;\n  color: #111827;\n  letter-spacing: -0.01em;\n}\n\n.alert-message {\n  font-size: 0.875rem;\n  color: #4b5563;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.alert-action {\n  flex-shrink: 0;\n  padding: 0.5rem 1rem;\n  background: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.alert-error .alert-action {\n  color: #ef4444;\n}\n\n.alert-warning .alert-action {\n  color: #f59e0b;\n}\n\n.alert-success .alert-action {\n  color: #10b981;\n}\n\n.alert-action:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n/* Taxa de Resposta */\n.response-rate-section {\n  margin-bottom: 2rem;\n}\n\n.response-rate-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 2rem;\n  border-radius: 16px;\n  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);\n  text-align: center;\n}\n\n.response-rate-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.response-rate-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 0.5rem;\n}\n\n.response-rate-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.response-rate-value {\n  font-size: 4rem;\n  font-weight: 800;\n  margin: 1rem 0;\n  line-height: 1;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.response-rate-subtitle {\n  font-size: 1rem;\n  opacity: 0.95;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.response-rate-details {\n  display: flex;\n  justify-content: center;\n  gap: 3rem;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.response-rate-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.response-rate-label {\n  font-size: 0.9rem;\n  opacity: 0.9;\n  font-weight: 500;\n}\n\n.response-rate-number {\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.metric-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.metric-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.metric-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.metric-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.metric-icon.nps {\n  background: linear-gradient(135deg, #FF8C00 0%, #FF6B00 100%);\n  color: white;\n}\n\n.metric-icon.csat {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n}\n\n.metric-icon.ces {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n  color: white;\n}\n\n.metric-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #333;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.metric-value-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n\n.metric-value {\n  font-size: 3rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #FF8C00 0%, #FF6B00 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.metric-goal-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.25rem;\n}\n\n.metric-goal {\n  font-size: 0.85rem;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.performance-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.metric-card.csat .metric-value {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.metric-card.ces .metric-value {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.metric-subtitle {\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 1rem;\n}\n\n.metric-details {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n}\n\n.metric-detail {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  background: #f9fafb;\n  border-radius: 6px;\n}\n\n.metric-detail-label {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.metric-detail-value {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #333;\n}\n\n.metric-detail-value.promoters {\n  color: #10b981;\n}\n\n.metric-detail-value.detractors {\n  color: #ef4444;\n}\n\n.metric-detail-value.passives {\n  color: #f59e0b;\n}\n\n.metric-detail-value.satisfied {\n  color: #10b981;\n}\n\n.metric-detail-value.low-effort {\n  color: #10b981;\n}\n\n.metric-detail-value.percentage {\n  color: #10b981;\n}\n\n.chart-section {\n  margin-bottom: 2rem;\n}\n\n.chart-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.chart-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.chart-subtitle {\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 1.5rem;\n}\n\n.charts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n/* ==========================================================================\n   Pesquisa de Manutenção — bloco próprio da campanha importada\n   ========================================================================== */\n\n.mnt-section {\n  background: white;\n  border-radius: 14px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0e6da;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.mnt-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding-bottom: 1.25rem;\n  border-bottom: 1px solid #f2f2f2;\n}\n\n.mnt-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n}\n\n.mnt-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #FF8C00, #ff6b00);\n  color: white;\n  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.28);\n  flex-shrink: 0;\n}\n\n.mnt-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #222;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.mnt-export {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid #ffdfc0;\n  border-radius: 8px;\n  background: #fff7ee;\n  color: #b45a00;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s;\n}\n\n.mnt-export:hover:not(:disabled) {\n  background: linear-gradient(135deg, #FF8C00, #ff6b00);\n  border-color: transparent;\n  color: white;\n  box-shadow: 0 3px 10px rgba(255, 140, 0, 0.25);\n}\n\n.mnt-export:disabled {\n  opacity: 0.6;\n  cursor: progress;\n}\n\n/* Abas de campanha */\n\n.mnt-tabs {\n  display: flex;\n  gap: 0.4rem;\n  margin-top: 1rem;\n  overflow-x: auto;\n  padding-bottom: 0.25rem;\n  scrollbar-width: thin;\n}\n\n.mnt-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.9rem;\n  border: 1px solid #eee;\n  border-radius: 999px;\n  background: #fafafa;\n  color: #666;\n  font-family: inherit;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  max-width: 360px;\n  transition: all 0.2s;\n}\n\n/* Só o nome encolhe; o contador não pode ser espremido pelo texto longo */\n.mnt-tab-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.mnt-tab:hover {\n  border-color: #ffd9ae;\n  color: #b45a00;\n}\n\n.mnt-tab.active {\n  background: linear-gradient(135deg, #FF8C00, #ff6b00);\n  border-color: transparent;\n  color: white;\n  box-shadow: 0 3px 10px rgba(255, 140, 0, 0.25);\n}\n\n.mnt-tab-count {\n  flex-shrink: 0;\n  padding: 0.05rem 0.45rem;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.06);\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.mnt-tab.active .mnt-tab-count {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* Feedbacks escritos */\n\n.mnt-feedback {\n  margin-top: 1rem;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  padding: 1.15rem;\n  background: #fdfdfd;\n}\n\n/* Reaproveita .comments-list / .comment-card da seção de Comentários; aqui só\n   ajustamos a altura, já que este bloco comporta uma lista mais longa. */\n/* Altura de ~5 cards (136px cada + 16px de gap), com folga para o topo do 6º\n   aparecer e sinalizar que a lista rola.\n   Especificidade dupla de propósito: `.comments-list` é declarada depois neste\n   arquivo e, com peso igual, venceria por ordem mantendo os 600px dela. */\n.comments-list.mnt-feedback-list {\n  max-height: 780px;\n}\n\n/* Badge de nota no formato dos badges de NPS/CSAT/CES, colorido pela faixa.\n   `color` vem depois das regras `.tone-*` genéricas, que pintariam o texto com\n   a mesma cor do fundo. */\n.comment-score.tone-good { background: #d1fae5; color: #047857; }\n.comment-score.tone-warn { background: #fef3c7; color: #b45309; }\n.comment-score.tone-bad { background: #fee2e2; color: #b91c1c; }\n.comment-score.tone-empty { background: #f3f4f6; color: #6b7280; }\n\n/* --- KPIs ---------------------------------------------------------------- */\n\n.mnt-kpis {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr) 1.9fr;\n  gap: 1rem;\n  margin: 1.25rem 0;\n}\n\n.mnt-kpi {\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n  transition: border-color 0.2s, transform 0.2s;\n}\n\n.mnt-kpi:hover {\n  border-color: #ffd9ae;\n  transform: translateY(-2px);\n}\n\n.mnt-kpi-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.6rem;\n}\n\n.mnt-kpi-icon.send { background: #eef2ff; color: #4f46e5; }\n.mnt-kpi-icon.answer { background: #ecfdf5; color: #059669; }\n.mnt-kpi-icon.rate { background: #fff7ee; color: #ea7c00; }\n\n.mnt-kpi-value {\n  font-size: 1.85rem;\n  font-weight: 800;\n  color: #222;\n  line-height: 1.1;\n  letter-spacing: -0.5px;\n}\n\n.mnt-kpi-value.accent { color: #FF8C00; }\n\n.mnt-kpi-label {\n  font-size: 0.8rem;\n  color: #777;\n  margin-top: 0.2rem;\n}\n\n.mnt-kpi-hint {\n  font-size: 0.72rem;\n  color: #999;\n  margin-top: 0.35rem;\n}\n\n.mnt-kpi-hint.warn { color: #c05600; font-weight: 600; }\n\n/* --- Nota média + distribuição -------------------------------------------- */\n\n.mnt-kpi.wide {\n  background: linear-gradient(135deg, #fffaf4, #fff);\n  border-color: #ffe6cc;\n}\n\n.mnt-score-area {\n  display: flex;\n  align-items: stretch;\n  gap: 1.25rem;\n}\n\n.mnt-score-main {\n  flex-shrink: 0;\n  min-width: 130px;\n}\n\n.mnt-score-value {\n  font-size: 2.6rem;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -1px;\n}\n\n.tone-good { color: #10b981; }\n.tone-warn { color: #f59e0b; }\n.tone-bad { color: #ef4444; }\n.tone-empty { color: #bbb; }\n\n/* Barra segmentada por faixa (promotores / neutros / detratores) */\n\n.mnt-bands {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.85rem;\n}\n\n.mnt-band-bar {\n  display: flex;\n  height: 26px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f1f1f1;\n}\n\n.mnt-band {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: width 0.5s ease;\n  min-width: 3px;\n}\n\n.mnt-band.tone-good { background: #10b981; }\n.mnt-band.tone-warn { background: #f59e0b; }\n.mnt-band.tone-bad { background: #ef4444; }\n\n.mnt-band-value {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: white;\n  letter-spacing: 0.2px;\n}\n\n.mnt-band-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem 1.1rem;\n}\n\n.mnt-band-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.76rem;\n  color: #666;\n}\n\n.mnt-band-item strong {\n  color: #333;\n  font-weight: 700;\n}\n\n.mnt-band-item em {\n  font-style: normal;\n  color: #aaa;\n  font-size: 0.7rem;\n}\n\n.mnt-band-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.mnt-band-dot.tone-good { background: #10b981; }\n.mnt-band-dot.tone-warn { background: #f59e0b; }\n.mnt-band-dot.tone-bad { background: #ef4444; }\n\n/* --- Frames lado a lado --------------------------------------------------- */\n\n.mnt-frames {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.mnt-frame {\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  padding: 1.15rem;\n  background: #fdfdfd;\n}\n\n.mnt-frame-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #333;\n}\n\n.mnt-frame-subtitle {\n  font-size: 0.78rem;\n  color: #999;\n  margin-bottom: 1.1rem;\n}\n\n.mnt-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 1.05rem;\n}\n\n.mnt-row-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.4rem;\n}\n\n.mnt-row-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #444;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mnt-row-score {\n  font-size: 1.05rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.mnt-track {\n  height: 8px;\n  background: #f1f1f1;\n  border-radius: 999px;\n  overflow: hidden;\n  margin-bottom: 3px;\n}\n\n.mnt-track.slim { height: 4px; }\n\n.mnt-fill {\n  height: 100%;\n  border-radius: 999px;\n  transition: width 0.5s ease;\n}\n\n.mnt-fill.volume { background: linear-gradient(90deg, #FF8C00, #ffb057); }\n.mnt-fill.rate { background: #10b981; }\n\n.mnt-row-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.72rem;\n  color: #888;\n  margin-top: 0.35rem;\n  flex-wrap: wrap;\n}\n\n.mnt-row-rate {\n  color: #059669;\n  font-weight: 700;\n}\n\n.mnt-dot { color: #ddd; }\n\n.mnt-empty {\n  padding: 1.5rem 0;\n  text-align: center;\n  color: #aaa;\n  font-size: 0.85rem;\n}\n\n@media (max-width: 1100px) {\n  .mnt-kpis { grid-template-columns: repeat(2, 1fr); }\n  .mnt-kpi.wide { grid-column: span 2; }\n  .mnt-frames { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 620px) {\n  .mnt-kpis { grid-template-columns: 1fr; }\n  .mnt-kpi.wide { grid-column: span 1; }\n  .mnt-score-area { flex-direction: column; gap: 1rem; }\n  .mnt-header { flex-direction: column; align-items: flex-start; }\n}\n\n.rankings-section {\n  margin-bottom: 2rem;\n}\n\n.charts-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 1.5rem;\n}\n\n.comments-section {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.comments-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.comments-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #333;\n}\n\n.comments-filter {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.comments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.comment-card {\n  padding: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  transition: border-color 0.2s;\n}\n\n.comment-card:hover {\n  border-color: #FF8C00;\n}\n\n.comment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.comment-info {\n  flex: 1;\n}\n\n.comment-protocol {\n  font-weight: 700;\n  color: #FF8C00;\n  font-size: 0.95rem;\n}\n\n.comment-protocol-link {\n  font-weight: 700;\n  color: #FF8C00;\n  font-size: 0.95rem;\n  text-decoration: none;\n  transition: all 0.2s;\n  display: inline-block;\n}\n\n.comment-protocol-link:hover {\n  color: #FF6B00;\n  text-decoration: underline;\n  transform: translateX(2px);\n}\n\n/* Pesquisas importadas: identificador sem link para o CRM */\n.comment-protocol-static:hover {\n  color: #FF8C00;\n  text-decoration: none;\n  transform: none;\n  cursor: default;\n}\n\n.comment-meta {\n  font-size: 0.85rem;\n  color: #666;\n  margin-top: 0.25rem;\n}\n\n.comment-branch-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.1rem 0.6rem;\n  background: #fff4e8;\n  border: 1px solid #ffd9ae;\n  border-radius: 999px;\n  color: #c05600;\n  font-weight: 600;\n  font-size: 0.8rem;\n  vertical-align: middle;\n}\n\n.comment-branch-badge svg {\n  flex-shrink: 0;\n}\n\n.comment-scores {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.comment-score {\n  padding: 0.25rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n.comment-score.nps {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.comment-score.csat {\n  background: #fce7f3;\n  color: #ec4899;\n}\n\n.comment-score.ces {\n  background: #dbeafe;\n  color: #3b82f6;\n}\n\n.comment-text {\n  font-size: 0.9rem;\n  color: #333;\n  line-height: 1.6;\n  padding: 0.75rem;\n  background: #f9fafb;\n  border-radius: 6px;\n  border-left: 3px solid #FF8C00;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 1.1rem;\n  color: #666;\n}\n\n.error {\n  background: #fef2f2;\n  color: #ef4444;\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid #fee2e2;\n  margin: 1rem 0;\n}\n\n@media (max-width: 768px) {\n  .metrics-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .charts-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .filters-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .comment-header {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .comment-scores {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
